/* eslint-env browser */

'use strict';

const { h } = require('phy');
const CheckCircleSolid = require('@design-system/svg-icons/preact/CheckCircleSolid')
  .default;
const ErrorSolid = require('@design-system/svg-icons/preact/ErrorSolid')
  .default;

const { APPLIED, ERROR } = require('../../constants');
const ApplyPromoCodeComponent = require('../../components/apply_promo_code_component');
const ApplyPromoCodeContainer = require('../apply_promo_code_container');
const NotificationComponent = require('./../../components/notification_component');

class ApplyPromoCodeContainerDesktop extends ApplyPromoCodeContainer {
  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
    const newProps = this.getNewProps();
    switch (this.state.promoApplied) {
      case APPLIED: {
        return h(
          '.success-container',
          h(CheckCircleSolid),
          h(NotificationComponent, {
            ...this.props,
            bhw: 'ClickToApplyPromoCodeInfo',
            messageText: this.state.successMessage,
            notificationKlass: this.state.notificationKlass,
          })
        );
      }
      case ERROR: {
        return h(
          '.apply-code-error-wrapper',
          h(ApplyPromoCodeComponent, {
            ...newProps,
            handleApplyClick: this.handleApplyClick,
          }),
          h(
            '.error-container',
            h(ErrorSolid),
            h(NotificationComponent, {
              ...this.props,
              bhw: 'ClickToApplyPromoCodeError',
              messageText: this.state.errorMessage,
              notificationKlass: this.state.notificationKlass,
            })
          )
        );
      }
      default: {
        return this.handleDefaultCase(newProps);
      }
    }
  }
}

module.exports = ApplyPromoCodeContainerDesktop;
